import React from 'react';
import Uganda1_primary_subjects from './uganda1_primary_subjects';

const Uganda1_primary = () => {
  return (
    <div>
      <Uganda1_primary_subjects />
    </div>
  );
}

export default Uganda1_primary;
